(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function target(el) {
    var mode = el.dataset.mode, now = new Date();
    if (mode === 'christmas') {
      var x = new Date(now.getFullYear(), 11, 25, 0, 0, 0);
      if (now >= x) x = new Date(now.getFullYear() + 1, 11, 25, 0, 0, 0);
      return x;
    }
    var d = new Date(el.dataset.end);
    return isNaN(d) ? null : d;
  }
  function tick() {
    document.querySelectorAll('[data-gm-cd]').forEach(function (el) {
      var t = el._gmT || (el._gmT = target(el));
      if (!t) { el.style.display = 'none'; return; }
      var s = Math.max(0, Math.floor((t - new Date()) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var f = function (k, v) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = pad(v); };
      if (el.querySelector('[data-d]')) { f('d', d); f('h', h); } else { f('h', d * 24 + h); }
      f('m', m); f('s', sec);
    });
  }
  tick(); setInterval(tick, 1000);

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var withSep = function (sep, dec) { return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + dec + parts[1]; };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return withSep('.', ',');
      if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (k === 'amount_with_apostrophe_separator') return withSep("'", '.');
      return withSep(',', '.');
    });
  }

  function init(root) {
    if (root.dataset.gmInit) return;
    root.dataset.gmInit = '1';
    var fmt = root.dataset.money || '€{{amount_with_comma_separator}}';

    var main = root.querySelector('[data-gm-main]');
    var thumbs = root.querySelectorAll('[data-gm-thumb]');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        if (main) { main.src = b.dataset.src; main.removeAttribute('srcset'); }
      });
    });

    var offers = root.querySelectorAll('[data-gm-offer]');
    var totalEl = root.querySelector('[data-gm-total]');
    var stickyPrice = root.querySelector('[data-gm-sticky-price]');
    var stickyQty = root.querySelector('[data-gm-sticky-qty]');
    var active = function () { return root.querySelector('[data-gm-offer].is-active') || offers[0]; };
    var update = function () {
      var o = active(); if (!o) return;
      var sum = +o.dataset.final, qty = +o.dataset.qty;
      root.querySelectorAll('[data-gm-addon]:checked').forEach(function (c) { sum += +c.dataset.price; qty += 1; });
      var txt = money(sum, fmt);
      if (totalEl) totalEl.textContent = txt;
      if (stickyPrice) stickyPrice.textContent = txt;
      if (stickyQty) stickyQty.textContent = qty;
    };
    var pick = function (o) {
      offers.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
      o.classList.add('is-active'); o.setAttribute('aria-checked', 'true');
      update();
    };
    if (offers.length && !root.querySelector('[data-gm-offer].is-active')) pick(offers[0]);
    offers.forEach(function (o) {
      o.addEventListener('click', function () { pick(o); });
      o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(o); } });
    });
    root.querySelectorAll('[data-gm-addon]').forEach(function (c) { c.addEventListener('change', update); });
    update();

    var btn = root.querySelector('[data-gm-atc]');
    var err = root.querySelector('[data-gm-err]');
    var busy = false;
    var add = function (toCheckout) {
      if (busy || !btn) return;
      var o = active();
      var qty = o ? +o.dataset.qty : 1;
      var code = o ? o.dataset.code : '';
      var props = {};
      if (o && +o.dataset.giftbox > 0) props['GiftBox'] = o.dataset.giftbox + '× free';
      if (o && o.dataset.mystery === 'true') props['Mystery gift'] = '1× free';
      var items = [{ id: +btn.dataset.variant, quantity: qty, properties: props }];
      root.querySelectorAll('[data-gm-addon]:checked').forEach(function (c) { items.push({ id: +c.dataset.gmAddon, quantity: 1 }); });
      busy = true; btn.disabled = true; if (err) err.style.display = 'none';
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          var dest = (toCheckout || root.dataset.after === 'checkout') ? '/checkout' : base + 'cart';
          window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + dest : dest;
        })
        .catch(function (j) {
          busy = false; btn.disabled = false;
          if (err) { err.textContent = (j && (j.description || j.message)) || 'Something went wrong, please try again.'; err.style.display = 'block'; }
        });
    };
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); add(false); });
    var sb = root.querySelector('[data-gm-sticky-btn]');
    if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); add(true); });

    var sticky = root.querySelector('[data-gm-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          sticky.classList.toggle('is-on', !x.isIntersecting && x.boundingClientRect.top < 0);
        });
      }).observe(btn);
    }
  }
  function all() { document.querySelectorAll('[data-gm-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function () { all(); tick(); });
})();
